import React from 'react';
import PDFViewer from 'pdf-viewer-reactjs';

const link =
  'https://fh.filgolf.com/files/ele/I_Certification_of_Independent_Director.pdf';

export default function I() {
  return (
    <>
      <h5 className="is-size-5 mb-4">
        <strong>I. Certification of Independent Director</strong>
      </h5>
      <a className="button  is-link" href={link} download>
        DOWNLOAD
      </a>
      <PDFViewer
        document={{
          url: link
        }}
        rotationAngle={0}
        css="customViewer"
      />
    </>
  );
}
